export const MainConfig = {
    AppDetails: {
        app_name: "NewoTaxi", 
        app_description: "Newo Taxi",
        app_identifier: "com.newotaxis.app",
        ios_app_version: "1.0.0", 
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyAUa1PojBDj2Zdh9p95eoDCNJi6N-Pgmwo",
        authDomain: "newo-taxi.firebaseapp.com",
        databaseURL: "https://newo-taxi-default-rtdb.firebaseio.com",
        projectId: "newo-taxi",
        storageBucket: "newo-taxi.appspot.com",
        messagingSenderId: "290593719511",
        appId: "1:290593719511:web:9a776d44cb0084d52adc92",
        measurementId: "G-H9E5WCS102"
    },
    Google_Map_API_Key: {
        ios: "AIzaSyC4aJs-hi5UUBrCyuh98AE4HcBUq7GvuS8",
        android: "AIzaSyC4aJs-hi5UUBrCyuh98AE4HcBUq7GvuS8",
        web: "AIzaSyC4aJs-hi5UUBrCyuh98AE4HcBUq7GvuS8"
    },
    facebookAppId: "1029552854443983",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "",
        Buyer_Email_Address: ""
    }
}